import React from 'react';
import glamorous from 'glamorous';
import format from 'date-fns/format';
import blueLogoSvg from '../svgs/kairos-logo-blue.svg';
import whiteLogoSvg from '../svgs/kairos-logo-white.svg';
import { Flex, Span, CenterY, HeaderButton } from './hocs/withStyles';
import airports from '../airports';

const formatDate = date => format(date, 'D MMM');
const formatRange = (depDate, retDate) =>
  `${formatDate(depDate)} - ${formatDate(retDate)}`;

const HeaderBar = props => {
  const { route, departureDate, returnDate, origin, dates } = props;

  const currentDateRange = formatRange(departureDate, returnDate);
  const possibleDates = [
    [dates[1], dates[4]],
    [dates[1], dates[5]],
    [dates[2], dates[4]],
    [dates[2], dates[5]]
  ].map(d => {
    const depDate = d[0];
    const retDate = d[1];
    return {
      depDate,
      retDate,
      range: formatRange(depDate, retDate)
    };
  });

  return (
    <Flex
      width="100%"
      justifyContent="space-between"
      css={{
        backgroundColor: !route.name ? 'transparent' : 'white',
        margin: '0 auto',
        border: !route.name ? 0 : '1px solid #ECECEC'
      }}
    >
      <Flex>
        <CenterY
          p={[0, 1, 0, 2]}
          onClick={() => {
            window.location.hash = '';
          }}
          css={{
            ':hover': {
              cursor: route.name ? 'pointer' : 'cursor',
              opacity: route.name ? 0.6 : 1
            }
          }}
        >
          <glamorous.Img src={!route.name ? whiteLogoSvg : blueLogoSvg} width="24px" />
        </CenterY>
        <CenterY p={[0, 1]}>
          <h1
            style={{
              padding: 0,
              margin: 0,
              fontSize: '18px',
              fontWeight: 'normal',
              color: !route.name ? 'white' : 'black'
            }}
          >
            Kairos
          </h1>
        </CenterY>
        {route.name === 'from' && (
          <CenterY m={[0, 1]}>
            <Flex p={[1, 2]}>
              <select
                style={{
                  border: '1px solid #ECECEC',
                  backgroundColor: 'white',
                  padding: '0.5em',
                  height: '34px'
                }}
                value={origin}
                onChange={e => {
                  const newOrigin = e.target.value;
                  props.setOrigin(newOrigin);
                  window.location.hash = `/from/${newOrigin}`; // this doesn't trigger the fetch (in DidMount)
                  setTimeout(() => {
                    props.fetchDestisWithFares(newOrigin);
                  }, 0);
                }}
              >
                {airports.map((d, i) => (
                  <option key={d.code} value={d.code}>
                    {d.code}
                  </option>
                ))}
              </select>
            </Flex>
          </CenterY>
        )}
        {false && (
          // route.name === 'from' && (
          <CenterY m={[0, 1]}>
            <Flex>
              <select
                style={{
                  border: '1px solid #ECECEC',
                  backgroundColor: 'white',
                  padding: '0.5em',
                  height: '34px'
                }}
                value={currentDateRange}
                onChange={e => {
                  const match = possibleDates.find(o => o.range === e.target.value);
                  if (!match) return;
                  props.setDepartureDate(match.depDate);
                  props.setReturnDate(match.retDate);
                  setTimeout(() => {
                    // timeout else dates are not updated
                    props.fetchDestisWithFares(origin);
                  }, 0);
                }}
              >
                {possibleDates.map((d, i) => (
                  <option key={`${i}-${d.range}`} value={d.range}>
                    {d.range}
                  </option>
                ))}
              </select>
            </Flex>
          </CenterY>
        )}
      </Flex>
      {!route.name && (
        <CenterY>
          <Flex>
            <HeaderButton
              bg="blue"
              onClick={() => {
                window.location.hash = 'about';
              }}
            >
              <Span color="white">About Us</Span>
            </HeaderButton>
          </Flex>
        </CenterY>
      )}
    </Flex>
  );
};

export default HeaderBar;



// WEBPACK FOOTER //
// ./src/components/HeaderBar.js